import { NeedsBasedRecOption } from './nbr-filter/needs-based-rec-selection.atom';
import { ContentTabDataProps } from './nbr-filter/sections/content-tabs/content-tabs';
import { NeedsBasedRecLeftContentProps } from './nbr-filter/sections/left-content/left-content';
import { QuizProps } from './nbr-quiz/components/quiz-component/quiz-component.types';
import { NbrResultsProps } from './nbr-quiz/nbr-results/nbr-results';
import { ExplorationFlagsType } from '@exploration/feature-management';
import { HeadMetadata } from '@exploration/shared-types';

export enum MetricsOptions {
  nbrAdvisorConnectClick = 'NBR click on Connect Advisor metric',
  nbrClickOnLinks = 'NBR click on links metric',
  nbrButtonClick = 'Needs based rec button',
}

export interface NbrFilterProps extends NeedsBasedRecLeftContentProps {
  pillData?: {
    [NeedsBasedRecOption.PERSONALIZED_FINANCIAL_PLANNING]: string;
    [NeedsBasedRecOption.BUDGETING_AND_SAVING]: string;
    [NeedsBasedRecOption.DAY_TO_DAY_SPENDING]: string;
    [NeedsBasedRecOption.RETIREMENT_PLANNING]: string;
    [NeedsBasedRecOption.INVESTING]: string;
    [NeedsBasedRecOption.GENEROSITY_AND_GIVING]: string;
    [NeedsBasedRecOption.GETTING_INSURED]: string;
  };
  titleSectionData: {
    title: string;
    subtitle: string;
    inquiry: string;
  };
  contentTabData: ContentTabDataProps;
  isEmbedded?: boolean;
}
export interface NeedsBasedRecPageProps extends NbrFilterProps {
  metadata: HeadMetadata;
  nbrQuizData: QuizProps;
  nbrResultsData: NbrResultsProps;
  flags: ExplorationFlagsType;
}
